// extracted by mini-css-extract-plugin
module.exports = {"serviceQuestionsList":"service-questions-list-module--serviceQuestionsList--20dIG"};